export default function(el) {
    const video = el.querySelector(".dam-video__video");
    const button = el.querySelector(".dam-video__play-button");

    if(!video || !button) return;

    const modifyButtonClass = (actionType) => button.classList[actionType]("dam-video__play-button--disabled");

    video.addEventListener("pause", () => modifyButtonClass("remove"));

    video.addEventListener("play", () => modifyButtonClass("add"));

    button.addEventListener("click", () => {
        video.play();
        modifyButtonClass("add");
    });
}